var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#6576FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.33335H10.6667V5.33335C10.6667 5.15654 10.5965 4.98697 10.4715 4.86195C10.3465 4.73693 10.1769 4.66669 10.0001 4.66669C9.82327 4.66669 9.6537 4.73693 9.52868 4.86195C9.40365 4.98697 9.33341 5.15654 9.33341 5.33335V9.33335H5.33341C5.1566 9.33335 4.98703 9.40359 4.86201 9.52862C4.73699 9.65364 4.66675 9.82321 4.66675 10C4.66675 10.1768 4.73699 10.3464 4.86201 10.4714C4.98703 10.5964 5.1566 10.6667 5.33341 10.6667H9.33341V14.6667C9.33341 14.8435 9.40365 15.0131 9.52868 15.1381C9.6537 15.2631 9.82327 15.3334 10.0001 15.3334C10.1769 15.3334 10.3465 15.2631 10.4715 15.1381C10.5965 15.0131 10.6667 14.8435 10.6667 14.6667V10.6667H14.6667C14.8436 10.6667 15.0131 10.5964 15.1382 10.4714C15.2632 10.3464 15.3334 10.1768 15.3334 10C15.3334 9.82321 15.2632 9.65364 15.1382 9.52862C15.0131 9.40359 14.8436 9.33335 14.6667 9.33335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.58b5db8f.svg";
export { ForwardRef as ReactComponent };